module.exports = __webpack_public_path__ + "static/media/flip.ae78e7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/flip.png
// module id = 38
// module chunks = 0